import CartTotal from "components/Cart/CartTotal"
import React, {Fragment, Component} from "react"
import {Col, Row, Table} from "elemental-react16"
import {Button, Form, Icon, Modal, Image, Input, Message, Container} from "semantic-ui-react"
import {Link} from "react-router-dom"
import {observer} from "mobx-react"
import FooterCheckout from "pages/checkout/FooterCheckout"
import shop from "shop/shop"
import Typeahead from "components/Typeahead/Typeahead"
import QuickorderTable from "components/Quickorder/QuickorderTable"
import _ from "lodash"
import CSV from "components/CSV/CSV"
import Responsive from "react-responsive"
import { trackAddToCart } from "components/tracking/Tracking";

@observer
export default class QuickorderPage extends Component {

	state = {
		products : [],
		product  : false,
		count    : 0,
		searchKey: 0
	}

	componentDidMount() {
		shop.cart.hooks.changed.add( this.updateCart )
		this.setState( {
			sum: shop.cart.sum
		} )
	}

	componentWillUnmount() {
		shop.cart.hooks.changed.remove( this.updateCart )
	}

	updateCart = ( {cart} ) => {
		this.setState( {
			sum: cart.sum
		} )
	}

	handleRemoveProduct = ( productToRemove ) => {
		shop.cart.remove( productToRemove )
	}

	handleSelect = ( {product} ) => {
		console.log( `product`, product )
		if ( !product.price ) {
			shop.toast( `Produkt nicht erhältlich: ${product.title} ist nicht zum Kauf verfügbar`, "warning", false, "bottom" )
			return
		}
		product.count = 0
		product.visible = false

		window.setTimeout( () => {
			this.focusByQuerySelector( "#number-input" )
		}, 30 )

		!this.props.skipProductSelection && this.setState( {product} )
	}

	focusByQuerySelector = selector => {
		let el = document.querySelector( selector )
		if ( el ) el.focus()
	}

	resetForm = () => {
		console.log( "RESET FORM" )
		let product = this.state.product
		if ( !product ) return
		console.log( "resetForm", product, this.state.count )
		product.count = this.state.count || 1
		shop.cart.add( product )
		trackAddToCart(product.map_id, product.title)
		this.setState( {products: [...this.state.products, product], count: "", searchKey: this.state.searchKey + 1} )

		window.setTimeout( () => {
			this.focusByQuerySelector( "#typeahead-input" )
		}, 250 )
	}

	handleKeys = ( e ) => {
		const CHAR_ENTER = 13

		if ( e.charCode === CHAR_ENTER ) {
			this.resetForm()
			e.preventDefault()
			return false
		}
	}

	render() {
		const {product, value, searchKey} = this.state
		const {productsById, ready} = shop.cart
		if ( !ready ) return null
		return (<Fragment>
			<div className="accountPageBody">
			{shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus" && <Container className="" >
            	<div className="fr logoutButtonQuickOrderDiv">
            		<Link to="/logout/"><Button primary id="logoutButtonQuickOrder"><div className={"pt2 black-60"}><Icon name={"black-60 power off"}/>{translate( "Logout" )}</div></Button></Link></div>
          </Container>}
						<div className="container pt4 pb5">
							<div className="flex flex-row justify-between items-start" >
								<h1 className="page-title"><i className="icon-sort-alt-up icon-lg" /><strong>{translate( "Quickorder" )}</strong></h1>
								{/*<div className="tr"><Button style={{width: "200px", borderRadius: "35px", height: "50px", backgroundColor: "#ffffff", border: "2px solid #369678" }} as={Link} to="/home" ><p className="fw6">{translate("weiter Einkaufen")}</p></Button> </div> */}
							</div>
				
				
				<Row>
					<Col sm="1" md="3/4" className="pb3">
						<p>{translate( "quickorderpage.explain" )}</p>
					</Col>
					{/*					 */}
				</Row>


					<Responsive minWidth={768}>
						<section className="pb2 pt3 mb5 mt4 quickOrderBackground br4" >
					<Responsive minWidth={1150}>
						<Row className="pb3 pl2"  >
							<Col sm="1/2">
								<p className="tl f3 fw7"> {translate("quickorderpage.addmanual")} </p>
							</Col>
							<Col sm="1/2">
								<p className="tc f3 fw7">{translate( "quickorderpage.importproducts" )}</p>
							</Col>
							</Row>
						<Row className="pb3 pl2">
							<Col sm="1/2">
								<p className="tl f6 fw7"> {translate("quickorderpage.itemsearch")} </p>
								<p className="tl f6 "> {translate("quickorderpage.additemhint")} </p>
							</Col>
							<Col sm="1/2">
								<p className="tc f6 fw7"> {translate("quickorderpage.addmultiple")} </p>
								<p className="tc f6 "> {translate("quickorderpage.importhint")} </p>
							</Col>
							</Row>
						<Row className="pl2">
							<Col sm="1/3" >
							
								<label htmlFor="" className="fw7 f7">{translate( "add article" )}</label>
								<Typeahead id="defaultQuickOrder" key={searchKey} onSelectProduct={this.handleSelect} {... this.resetForm}/>
								{/*<Typeahead
									count={42} // TODO: THIS IS FOR HOTEX
									key={searchKey}
									artnr={0}
									onSelectProduct={this.handleSelect}
									fluid
									// onSelect={this.handleSelect}
									value={this.state.value}{... console.log("value: ",value)}
									placeholder={translate("Art.-Nr.")}
									onChange={( value ) => this.setState( {value} ) }{... console.log("STATEVALUE: ", this.state.value)}
								/>*/}
							</Col>
							<Col sm="1/4">
								<div className="fl"><label className="fw7 f7" htmlFor="">{translate( "amount in PU" )}: {/*product.unit_desc*/}</label>
								<div className="flex flex-row justify-between items-center" >
<Input style={{borderRadius: "35px", height: "45px"}} className="transparent ba b--black-20 bw1 pr3 pl3" type="number" min={1} placeholder={product.count || 1} 
						  
						  value={this.state.count || 1}
						  action 
						  onChange={e => {
							  this.setState({ count: e.target.value });
							  console.log("count",e.target.value, this.state.count)
						  }}
						  onBlur={e => {
							  if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
								shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
								e.target.value = Number(product.pinfos.minbuy);
								this.setState({ count: e.target.value });
								  
							  }
						  }}>
							<Button style={{borderRadius: "35px", backgroundColor: "transparent"}} icon="minus" onClick={() => {
								let newCount = Math.max((this.state.count ||  1) - 1);
								if(newCount < 1){
									newCount = 1

								}
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />
							<input style={{ width: "95px", height: "50", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
							{/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
									onChange={( e, data ) => {
									  const { value } = data
									  const ve = product.quantities.filter( q => q.map_desc_id === value )
									  if ( !ve ) return
									  product.unit_multi = ve[ 0 ].multi
									  product.unit_id = ve[ 0 ].map_desc_id
									  console.log( { data, e, value: e.target.value, target: e.target } )
									}
									}
							/>*/}
							
							<Button style={{borderRadius: "35px", backgroundColor: "transparent" }} className="mr2" icon="plus" onClick={() => {
								let newCount = (this.state.count ||  1) + 1;
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />


                          </Input>
								</div >
								<div className="pt2">
									<Button style={{width: "200px", borderRadius: "35px", height: "50px"}} onClick={() => {
										this.resetForm()
									}}
									 primary floated="right">{translate( "in den Warenkorb" )}</Button></div></div>
							</Col>
								{!shop.config.hideimport && <Col sm="1" md="1/3">
									
									<ProductImporter />
								</Col>}		
						</Row>
						</Responsive>
					<Responsive maxWidth={1149} minWidth={768}>
												<Row className="pb3 pl2"  >
							<Col sm="1/2">
								<p className="tl f3 fw7"> {translate("quickorderpage.addmanual")} </p>
							</Col>
							<Col sm="1/2">
								<p className="tc f3 fw7">{translate( "quickorderpage.importproducts" )}</p>
							</Col>
							</Row>
						<Row className="pb3 pl2">
							<Col sm="1/2">
								<p className="tl f6 fw7"> {translate("quickorderpage.itemsearch")} </p>
								<p className="tl f6 "> {translate("quickorderpage.additemhint")} </p>
							</Col>
							<Col sm="1/2">
								<p className="tc f6 fw7"> {translate("quickorderpage.addmultiple")} </p>
								<p className="tc f6 "> {translate("quickorderpage.importhint")} </p>
							</Col>
							</Row>
						<Row className="pl2">
							<Col sm="1/3" >
							
								<label htmlFor="" className="fw7 f7">{translate( "add article" )}</label>
								<Typeahead id="defaultQuickOrder" key={searchKey} onSelectProduct={this.handleSelect} {... this.resetForm}/>
								{/*<Typeahead
									count={42} // TODO: THIS IS FOR HOTEX
									key={searchKey}
									artnr={0}
									onSelectProduct={this.handleSelect}
									fluid
									// onSelect={this.handleSelect}
									value={this.state.value}{... console.log("value: ",value)}
									placeholder={translate("Art.-Nr.")}
									onChange={( value ) => this.setState( {value} ) }{... console.log("STATEVALUE: ", this.state.value)}
								/>*/}
						<div className="fl"><label className="fw7 f7" htmlFor="">{translate( "amount in PU" )}: {/*product.unit_desc*/}</label>
						<div className="flex flex-row justify-between items-center" >
						<Input style={{borderRadius: "35px", height: "45px"}} className="transparent ba b--black-20 bw1 pr3 pl3" type="number" min={1} placeholder={product.count || 1} 
						  
						  value={this.state.count || 1}
						  action 
						  onChange={e => {
							  this.setState({ count: e.target.value });
							  console.log("count",e.target.value, this.state.count)
						  }}
						  onBlur={e => {
							  if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
								shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
								e.target.value = Number(product.pinfos.minbuy);
								this.setState({ count: e.target.value });
								  
							  }
						  }}>
							<Button style={{borderRadius: "35px", backgroundColor: "transparent"}} icon="minus" onClick={() => {
								let newCount = Math.max((this.state.count ||  1) - 1);
								if(newCount < 1){
									newCount = 1

								}
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />
							<input style={{ width: "95px", height: "50", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
							{/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
									onChange={( e, data ) => {
									  const { value } = data
									  const ve = product.quantities.filter( q => q.map_desc_id === value )
									  if ( !ve ) return
									  product.unit_multi = ve[ 0 ].multi
									  product.unit_id = ve[ 0 ].map_desc_id
									  console.log( { data, e, value: e.target.value, target: e.target } )
									}
									}
							/>*/}
							
							<Button style={{borderRadius: "35px", backgroundColor: "transparent" }} className="mr2" icon="plus" onClick={() => {
								let newCount = (this.state.count ||  1) + 1;
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />


                          </Input>
						  									<Button style={{width: "200px", borderRadius: "35px", height: "50px"}} onClick={() => {
										this.resetForm()
									}}
									 primary floated="right">{translate( "in den Warenkorb" )}</Button>
								</div >
								<div className="pt2">
</div></div>
							</Col>
							<Col sm="1/4">

							</Col>
								{!shop.config.hideimport && <Col sm="1" md="1/3">
									
									<ProductImporter />
								</Col>}		
						</Row>
						</Responsive>
				</section>
				</Responsive>
				<Responsive maxWidth={767}>
					<div className="pb2 pt2 mb3  quickOrderBackground_mobile_1 br4" >
					<Row className="pb3 pl2"  >
					<Col sm="2/2">
						<p className="tl f3 fw7"> {translate("quickorderpage.addmanual")} </p>
					</Col>
					</Row>
					<Row className="pb3 pl2">
							<Col sm="2/2">
								<p className="tl f6 fw7"> {translate("quickorderpage.itemsearch")} </p>
								<p className="tl f6 "> {translate("quickorderpage.additemhint")} </p>
							</Col>
							</Row>
					<Row className="pl2">
													<Col sm="3/3" >
							
								<label htmlFor="" className="fw7 f7">{translate( "add article" )}</label>
								<Typeahead id="defaultQuickOrderMobile" key={searchKey} onSelectProduct={this.handleSelect} {... this.resetForm}/>
								{/*<Typeahead
									count={42} // TODO: THIS IS FOR HOTEX
									key={searchKey}
									artnr={0}
									onSelectProduct={this.handleSelect}
									fluid
									// onSelect={this.handleSelect}
									value={this.state.value}{... console.log("value: ",value)}
									placeholder={translate("Art.-Nr.")}
									onChange={( value ) => this.setState( {value} ) }{... console.log("STATEVALUE: ", this.state.value)}
								/>*/}
						<div className="fl"><label className="fw7 f7" htmlFor="">{translate( "amount in PU" )}: {/*product.unit_desc*/}</label>
						<div className="flex flex-row justify-between items-center" >
						<Input style={{borderRadius: "35px", height: "45px"}} className="transparent ba b--black-20 bw1 pr3 pl3" type="number" min={1} placeholder={product.count || 1} 
						  
						  value={this.state.count || 1}
						  action 
						  onChange={e => {
							  this.setState({ count: e.target.value });
							  console.log("count",e.target.value, this.state.count)
						  }}
						  onBlur={e => {
							  if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
								shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
								e.target.value = Number(product.pinfos.minbuy);
								this.setState({ count: e.target.value });
								  
							  }
						  }}>
							<Button style={{borderRadius: "35px", backgroundColor: "transparent"}} icon="minus" onClick={() => {
								let newCount = Math.max((this.state.count ||  1) - 1);
								if(newCount < 1){
									newCount = 1

								}
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />
							<input style={{ width: "95px", height: "50", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
							{/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
									onChange={( e, data ) => {
									  const { value } = data
									  const ve = product.quantities.filter( q => q.map_desc_id === value )
									  if ( !ve ) return
									  product.unit_multi = ve[ 0 ].multi
									  product.unit_id = ve[ 0 ].map_desc_id
									  console.log( { data, e, value: e.target.value, target: e.target } )
									}
									}
							/>*/}
							
							<Button style={{borderRadius: "35px", backgroundColor: "transparent" }} className="mr2" icon="plus" onClick={() => {
								let newCount = (this.state.count ||  1) + 1;
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />


                          </Input>
						  									<Button style={{width: "200px", borderRadius: "35px", height: "50px"}} onClick={() => {
										this.resetForm()
									}}
									 primary floated="right">{translate( "in den Warenkorb" )}</Button>
								</div ></div>
							</Col>
						</Row>
						</div>
						<div className="pb2 pt2 mb3  quickOrderBackground_mobile_2 br4" >
						<Row className="pb3 pl2"  >
							<Col sm="2/2">
								<p className="tl  f3 fw7"> {translate("quickorderpage.importproducts")} </p>
							</Col>
						</Row>
						<Row className="pb3 pl2">
							<Col sm="2/2">
								<p className="tl f6 fw7"> {translate("quickorderpage.addmultiple")} </p>
								<p className="tl f6 "> {translate("quickorderpage.importhint")} </p>
							</Col>
						</Row>
						<Row className="pl2">
							<Col sm="2/2">
								<ProductImporter />
							</Col>
						</Row>
						</div>
				</Responsive>
				<section className="pt3">
					<div className="f3 fw7">{translate( "cart.cart" )}</div>
					<QuickorderTable handleRemoveProduct={this.handleRemoveProduct} products={productsById}
									 onChange={( {product} ) => {
										 shop.cart.add( product )
										 trackAddToCart(product.map_id, product.title)
									 }} />
				</section>


				<section className={"cf pb3"}>
					<FooterCheckout  activeStep={100}/>
				</section>
				
				{/*TYPEAHEAD*/}
				
				<div className="fr pt5">
					</div>

			</div>
		</div>
		</Fragment>)

	}
}

class ProductImporter extends Component {

	state = {
		open: false
	}

	render() {
		const {open} = this.state
		return (
			<div className="tc pt3">
				<div className="pt1"></div>
				<Responsive minWidth={768}>
					<Button style={{ borderRadius: "35px", width: "100%" , height: "50px"}} primary fluid onClick={() => this.setState( {open: true} )}>{translate( "Produkte importieren" )}</Button>
					</Responsive>
				<Responsive maxWidth={767}>
					<Button style={{ borderRadius: "35px", height: "50px", width: "100%" , minWidth: "100%"}} primary fluid onClick={() => this.setState( {open: true} )}>{translate( "Produkte importieren" )}</Button>
				</Responsive>
				<Modal
					closeIcon={<Icon name="close" />}
					open={open}
					onClose={() => {
						this.setState( {open: false} )
					}}
					size="tiny"
				>
					<Modal.Header>{translate( "import products" )}</Modal.Header>
					<Modal.Content>
						<CSV onResult={( {products} ) => {
							_.each( products, (product => {
									shop.cart.add( product )
									trackAddToCart(product.map_id, product.title)
								})
							)
							shop.toast( translate( "products successfully imported" ) )
							this.setState( {open: false} )
						}
						} />
					</Modal.Content>

					<div className="bg-silver pa4">
						<p>{translate( "UPLOAD_NOTIFICATION" )}<a
							download={`Bestellvorlage.csv`}
							href="/Bestellvorlage.csv">{`Bestellvorlage.csv`}</a>.</p>
						<p>{translate( "Die Daten müssen, wie in der Bestellvorlage.csv vorgegeben, wie folgt abgelegt werden: " )}<br/></p>
						<Table>
							<tr>
								<td>Vorgabe</td>
								<td>ARTIKELNUMMER,MENGE</td>
							</tr>
							<tr>
								<td>Beispiel</td>
								<td>ART-10261,2</td>
							</tr>
						</Table>
					</div>
					<div className="bg-silver pa4">
						<p>{translate( "Beispieldarstellung in Excel: " )}</p>
						<Image src="/../bestellvorlageBSP.PNG"></Image>
					</div>

					{/*<Modal.Actions>*/}
					{/*/!*<Button positive icon="checkmark" labelPosition="right" content="Yes" />*!/*/}
					{/*</Modal.Actions>*/}
				</Modal>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/quickorder/QuickorderPage.js